import { useState } from 'react';

const CATEGORY_IMAGE_BASE_PATH = '/images/ingredient-categories';

/**
 * Static assets (public/) are served from the blend-builder app host (app.theojasya.com),
 * not from the Shopify page origin (www.theojasya.com). shopify-loader.js sets
 * window.__OJASYA_BLEND_BUILDER_ASSET_BASE__ before React mounts.
 */
function resolveAssetBaseUrl() {
  if (typeof window !== 'undefined' && window.__OJASYA_BLEND_BUILDER_ASSET_BASE__) {
    return window.__OJASYA_BLEND_BUILDER_ASSET_BASE__.replace(/\/$/, '');
  }
  const fromEnv = process.env.REACT_APP_STATIC_ASSET_BASE || process.env.PUBLIC_URL || '';
  return fromEnv.replace(/\/$/, '');
}

function categoryImageFilename(groupKey) {
  if (!groupKey) {
    throw new Error('Category image requires groupKey');
  }
  return `${groupKey.replace(/_/g, '-')}.webp`;
}

function resolveCategoryImageSrc(groupKey) {
  const base = resolveAssetBaseUrl();
  return `${base}${CATEGORY_IMAGE_BASE_PATH}/${categoryImageFilename(groupKey)}`;
}

function CategoryCardImage({ groupKey, emoji, label, imageAlt }) {
  const [imageFailed, setImageFailed] = useState(false);
  const showPhoto = !imageFailed;

  return (
    <div
      className={[
        'category-card__image',
        `category-card__image--${groupKey}`,
        showPhoto ? 'category-card__image--has-photo' : '',
      ].join(' ')}
    >
      {showPhoto && (
        <img
          src={resolveCategoryImageSrc(groupKey)}
          alt={imageAlt || label}
          loading="lazy"
          decoding="async"
          onError={() => setImageFailed(true)}
        />
      )}
      {!showPhoto && (
        <span className="category-card__emoji" aria-hidden>
          {emoji}
        </span>
      )}
    </div>
  );
}

export default CategoryCardImage;
